import CustomTable from "../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { Tooltip } from "@mui/material";
import moment from "moment";
const columnHelper = createMRTColumnHelper();

const columns = [
  // Created At Column
  columnHelper.accessor("createdAt", {
    header: "Date",
    size: 200,
    Cell: (cell) => moment(cell.row.original?.createdAt).format("DD MMM YYYY"),
  }),
  columnHelper.accessor("refinery", {
    header: "Refinery",
    size: 350,
    Cell: (cell) => (
      <Tooltip title={cell.row.original?.refinery || "No refinery"}>
        <span>{cell.row.original?.refinery == "augmont" ? "Augmont" : "MMTC-PAMP"}</span>
      </Tooltip>
    ),
  }),
  // Description Column
  columnHelper.accessor("description", {
    header: "Description",
    size: 350,
    Cell: (cell) => (
      <Tooltip title={cell.row.original?.description || "No Description"}>
        <span>{cell.row.original?.description}</span>
      </Tooltip>
    ),
  }),


  // Gram Column
  columnHelper.accessor("gram", {
    header: "Buy (g)",
    size: 150,
    Cell: (cell) =>
      cell.row.original?.type == "buy" ? cell.row.original?.gram : "",
  }),

  // Gram Column
  columnHelper.accessor("gram", {
    header: "Sell (g)",
    size: 150,
    Cell: (cell) =>
      cell.row.original?.type == "sell" ? cell.row.original?.gram : "",
  }),
  columnHelper.accessor("gram", {
    header: "Redeem (g)",
    size: 150,
    Cell: (cell) =>
      cell.row.original?.type == "redeem" ? cell.row.original?.gram : "",
  }),

  // Amount Column
  columnHelper.accessor("amount", {
    header: "Amount (₹)",
    size: 150,
    Cell: (cell) => cell.row.original?.amount || "",
  }),

  // Balance Column
  columnHelper.accessor("balance", {
    header: "Balance (g)",
    size: 150,
    Cell: (cell) => cell.row.original?.balance || "",
  }),
];

const UserProfileTable = ({ GoldData, SilverData }) => {
  return (
    <>
      <CustomTable columns={columns} data={GoldData || SilverData} />
    </>
  );
};

export default UserProfileTable;
